/**
 * Refresh app when "R" key is pressed 3 times
 */
export var initRefreshService = function () {
    var previousKeys = [];
    var handler = function (e) {
        previousKeys.push(e.key);
        if (previousKeys.length > 3) {
            previousKeys = [previousKeys[1], previousKeys[2], previousKeys[3]];
        }
        if (previousKeys[0] === 'r' && previousKeys[1] === 'r' && previousKeys[2] === 'r') {
            window.location.reload();
        }
    };
    window.addEventListener('keypress', handler);
};
